export default __webpack_public_path__ + "static/Step-4-f4ad311dcea92d7696774e866147d84c.svg";